import React, { useContext } from 'react'
import { QlikUIContext } from '../../QlikUIContext';
import { Script } from '../Script';
import { Style } from '../Style';

export const InvoicesList = () => {

    let jQueryLoaded = window.jQuery !== undefined;
    let bootstrapLoaded = jQueryLoaded;
    if (jQueryLoaded) {
        bootstrapLoaded = typeof($.fn.dropdown) !== 'undefined';
    }
    let zoneLoaded = window.Zone !== undefined;

    const context = useContext(QlikUIContext);

   return (
        <React.Fragment>
            {
                <div>
                    <Script src={`${context.invoicesListPath}inline.bundle.js`} async={false} />     

                    {
                        !jQueryLoaded && <Script src={context.jQueryPath} async={false} />
                    }
                    
                    {
                        !bootstrapLoaded && <Script src={context.bootstrapJsPath} async={false} />
                    }

                    {
                        !zoneLoaded && <Script src={`${context.templateConfigPath}polyfills.bundle.js`} async={false} />
                    }

                    <Script src={`${context.invoicesListPath}vendor.bundle.js`} async={false} />
                    <Script src={`${context.invoicesListPath}main.bundle.js`} async={false} />

                    <Style src={`${context.invoicesListPath}styles.bundle.css`} />
                    <Style src={context.bootstrapCssPath} />

                    <div className="row">
                        <div className="col-xs-12">
                            <span className="titulo-nivel1">
                                Generación de documentos relacionados con factura
                            </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="titulo-nivel1-bar"></div>
                        </div>
                    </div>
                    <base href="" />
                    <app-root id="idListFacturas"
                        security-token={context.securityToken}
                        subscription={context.subscription}
                        api-endpoint={context.conceptApiEndpoint}></app-root>
                </div>
            }

        </React.Fragment>
    );
}